import PropTypes from 'prop-types';

import NotesTable from "../common/components/NotesTable";
import useNetwork from '../common/hooks/networkHook';
import useCredentials from "../common/hooks/credentialsHook";

import { useJobCrews } from '../reducers/crewSlice';
import { createNote, strikeNote, useJobNotes } from '../reducers/jobNoteSlice';
import { useJobOutsideAgencies } from '../reducers/outsideAgencySlice';
import JobConversation from './JobConversation';
import { nowISOString } from '../common/utils/dateUtils';
import useClientConfig from '../common/hooks/clientConfigHook';

/**
 * Render job notes in a list with a text box to add new notes and option to strike an incorrect entry
 * @component
 */
const JobNote = ({ jobid, disabled = false, convMode = false }) => {
    const clientConfig = useClientConfig();
    const network = useNetwork();
    const credentials = useCredentials();
    const notes = useJobNotes(jobid);
    const jobCrews = useJobCrews(jobid);
    const jobAgencies = useJobOutsideAgencies(jobid);

    const handleAdd = (note, author) => createNote(network, { author, username: credentials.username, note, jobid, autogenerated: 0, timestamp: nowISOString(), tz: clientConfig.tz });
    const handleStrike = (note, strike_reason, strike_username, strike_timestamp) => strikeNote(network, { id: note.id, jobid, strike_reason, strike_username, strike_timestamp });

    return <div style={{ height: 'max(250px, min(calc(50vh), 550px))'}}>
        {convMode ? <JobConversation jobid={jobid}></JobConversation> : 
            <NotesTable notes={notes} tz={clientConfig.tz} authors={jobCrews.map(c => c.displayid).concat(jobAgencies.map(a => a.displayid))} disabled={disabled} onAdd={handleAdd} onStrike={handleStrike} partialOfflineSupport></NotesTable>
        }
    </div>
}

JobNote.propTypes = {
    /**
     * The jobid whose notes are to be displayed
     */
    jobid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

    /**
     * Force the input to be read-only
     */
    disabled: PropTypes.bool,

    /**
     * Set the display mode to conversation view
     */
    convMode: PropTypes.bool
}

export default JobNote;